import { MonitoringWaitressReport } from '@/routes/elements';

const WaitressPage = () => <MonitoringWaitressReport />;

export default WaitressPage;
